<template>
  <TransitionRoot appear :show="menuOpen" as="template">
    <Dialog as="div" class="relative z-[120]" @close="closeMenu">
      <TransitionChild
        as="template"
        enter="duration-200 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-150 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black/30" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-4 text-center">
          <TransitionChild
            as="template"
            enter="duration-200 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-150 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel class="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-5 text-left align-middle shadow-xl transition-all">
              <DialogTitle as="h3" class="text-base font-semibold text-slate-800">
                Telefon Islemleri
              </DialogTitle>
              <p class="mt-1 text-sm text-slate-600">
                {{ label || phone }}
              </p>

              <div class="mt-4 space-y-2">
                <button
                  type="button"
                  class="w-full rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-left text-sm font-medium text-emerald-800 hover:bg-emerald-100"
                  @click="openWhatsapp"
                >
                  1- Kendi WhatsApp'indan mesaj gonder
                </button>

                <button
                  type="button"
                  class="w-full rounded-lg border border-indigo-200 bg-indigo-50 px-3 py-2 text-left text-sm font-medium text-indigo-800 hover:bg-indigo-100"
                  @click="openHistory"
                >
                  2- Daha onceki gorusmeler
                </button>

                <button
                  type="button"
                  class="w-full rounded-lg border border-sky-200 bg-sky-50 px-3 py-2 text-left text-sm font-medium text-sky-800 hover:bg-sky-100"
                  @click="callFromMyPhone"
                >
                  3- Kendi telefonundan ara
                </button>

                <button
                  type="button"
                  class="w-full rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-left text-sm font-medium text-amber-800 hover:bg-amber-100"
                  :disabled="companyCallLoading"
                  @click="callFromCompanyPhone"
                >
                  4- {{ companyCallLoading ? 'Arama baslatiliyor...' : 'Sirket telefonundan ara' }}
                </button>
              </div>

              <p v-if="companyCallError" class="mt-3 rounded-lg bg-rose-50 px-3 py-2 text-xs text-rose-700">
                {{ companyCallError }}
              </p>

              <div class="mt-4 flex justify-end">
                <button
                  type="button"
                  class="rounded-md border border-slate-300 px-3 py-1.5 text-sm text-slate-700 hover:bg-slate-50"
                  @click="closeMenu"
                >
                  Kapat
                </button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>

  <Teleport to="body" :disabled="!historyOpen">
    <div v-if="historyOpen" class="fixed inset-0 z-[130]">
      <div class="absolute inset-0 bg-black/35" @click="closeHistory"></div>
      <div class="absolute right-0 top-0 h-full w-full max-w-5xl bg-white shadow-2xl border-l border-slate-200 flex flex-col">
        <div class="flex items-center justify-between border-b border-slate-200 px-4 py-3">
          <div>
            <p class="text-sm font-semibold text-slate-800">Daha Onceki Gorusmeler</p>
            <p class="text-xs text-slate-500">{{ label || phone }}</p>
          </div>
          <div class="flex items-center gap-2">
            <a
              :href="historyUrl"
              target="_blank"
              class="rounded-md border border-slate-300 px-2 py-1 text-xs text-slate-700 hover:bg-slate-50"
            >
              Yeni sekmede ac
            </a>
            <button
              type="button"
              class="rounded-md border border-slate-300 px-2 py-1 text-xs text-slate-700 hover:bg-slate-50"
              @click="closeHistory"
            >
              Kapat
            </button>
          </div>
        </div>

        <iframe
          v-if="historyUrl"
          :src="historyUrl"
          class="h-full w-full"
          frameborder="0"
        ></iframe>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue'
import axios from 'axios'

const auth = useUser()
const config = useRuntimeConfig()
const companyCallLoading = ref(false)
const companyCallError = ref('')
const {
  menuOpen,
  historyOpen,
  phone,
  label,
  historyUrl,
  closeMenu,
  openHistory,
  closeHistory,
} = usePhoneActions()

const openWhatsapp = () => {
  if (!phone.value) return
  window.open(`https://wa.me/${phone.value}`, '_blank')
}

const callFromMyPhone = () => {
  if (!phone.value) return
  window.open(`tel:${phone.value}`, '_self')
}

const callFromCompanyPhone = async () => {
  const dial = (auth.value as Record<string, any> | null)?.U_Dial
  if (!phone.value || !dial) return
  const confirmText = `Bu arama sirket hatti uzerinden yapilacak.\nDahili: ${dial}\nAranacak Numara: ${phone.value}\n\nDevam etmek istiyor musunuz?`
  if (!window.confirm(confirmText)) return
  companyCallLoading.value = true
  companyCallError.value = ''
  try {
    await axios.post(`${config.public.apiBase}/verimor/originate`, {
      phone: phone.value,
    }, {
      withCredentials: true,
      headers: useHeader()?.value,
    })
    closeMenu()
  } catch (error: any) {
    companyCallError.value = error?.response?.data?.message || 'Sirket hattindan arama baslatilamadi.'
  } finally {
    companyCallLoading.value = false
  }
}
</script>
